import { cn } from "@omni/utils/styles";

export const ProductSkeleton = () => {
    return (
        <div
            className={cn(
                "tw:w-full tw:bg-grey tw:rounded-sm tw:aspect-square"
            )}
        />
    );
};
